import React, { useEffect, useState, useRef } from 'react';

export default function TextShowMore(props) {
  const letterSize = 6.5;
  const { text, tableRow = null } = props;
  const [showAll, setShowAll] = useState(false);
  const [width, setWidth] = useState(280);
  const ref = useRef(null);

  useEffect(() => {
    setWidth(ref.current?.clientWidth);
  }, [ref]);

  useEffect(() => {
    const getListSize = () => {
      const newWidth = ref.current?.clientWidth;
      if (newWidth) setWidth(newWidth);
    };

    window.addEventListener('resize', getListSize);
    return () => window.removeEventListener('resize', getListSize);
  }, []);

  if (!(typeof text === 'string')) {
    return text;
  }

  const defaultTextStyle = { whiteSpace: 'normal' };
  const wrapTextStyle = { whiteSpace: 'normal', wordWrap: 'break-word' };

  // Combined condition: If the text is 25 characters or less, OR it fits within the container width
  if (text.length <= 30 || text.length * letterSize < width) {
    return <span style={defaultTextStyle}>{text}</span>;
  }

  if (showAll) {
    return (
      <>
        <span style={tableRow ? wrapTextStyle : defaultTextStyle}>{text}</span>
        <a
          href="#setShowAll"
          data-hover="Show less"
          className="lox-hover-text"
          onClick={(e) => {
            e.preventDefault();
            setShowAll(!showAll);
          }}
        >
          {' '}
          …⤴︎
        </a>
      </>
    );
  }

  return (
    <p ref={ref}>
      <span style={defaultTextStyle}>
        {text.substring(0, Math.round(width / letterSize))}
      </span>
      <a
        data-hover="Show more"
        className="lox-hover-text"
        href="#setShowAll"
        onClick={(e) => {
          e.preventDefault();
          setShowAll(!showAll);
        }}
      >
        …⤵︎
      </a>
    </p>
  );
}
